<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
  text: { type: String, default: '' },
  className: { type: String, default: '' },
});

const reduceMotion = ref(false);
let mediaQuery;
let onMotionChange;

onMounted(() => {
  mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  reduceMotion.value = mediaQuery.matches;
  onMotionChange = event => {
    reduceMotion.value = event.matches;
  };
  mediaQuery.addEventListener('change', onMotionChange);
});

onBeforeUnmount(() => {
  mediaQuery?.removeEventListener('change', onMotionChange);
});

const transitionHooks = computed(() => {
  if (reduceMotion.value) {
    return {
      enterActiveClass: '',
      enterFromClass: '',
      enterToClass: '',
      leaveActiveClass: '',
      leaveFromClass: '',
      leaveToClass: '',
    };
  }

  return {
    enterActiveClass:
      'transition duration-200 ease-[cubic-bezier(0.23,1,0.32,1)]',
    enterFromClass: 'opacity-0 [transform:rotateX(-70deg)]',
    enterToClass: 'opacity-100 [transform:rotateX(0deg)]',
    leaveActiveClass:
      'absolute transition duration-150 ease-[cubic-bezier(0.23,1,0.32,1)]',
    leaveFromClass: 'opacity-100 [transform:rotateX(0deg)]',
    leaveToClass: 'opacity-0 [transform:rotateX(70deg)]',
  };
});
</script>

<template>
  <span
    class="relative inline-grid min-w-0 overflow-hidden align-bottom [perspective:120px] [transform-style:preserve-3d]"
    :class="className"
  >
    <span
      class="invisible col-start-1 row-start-1 truncate pointer-events-none"
      aria-hidden="true"
    >
      {{ text }}
    </span>
    <Transition
      mode="out-in"
      :enter-active-class="transitionHooks.enterActiveClass"
      :enter-from-class="transitionHooks.enterFromClass"
      :enter-to-class="transitionHooks.enterToClass"
      :leave-active-class="transitionHooks.leaveActiveClass"
      :leave-from-class="transitionHooks.leaveFromClass"
      :leave-to-class="transitionHooks.leaveToClass"
    >
      <span
        :key="text"
        class="col-start-1 row-start-1 truncate origin-center [backface-visibility:hidden]"
      >
        {{ text }}
      </span>
    </Transition>
  </span>
</template>
